module.exports = __webpack_public_path__ + "img/icon-motor-vehicle-theft.f39e0fd0.svg";